import { isAppRoutePath } from '@/libs/staticExportRedirect';

export const AUTH_RETURN_PATH_KEY = 'eezi.auth.returnPath';

const getQueryStringValue = (value: string | string[] | undefined): string | undefined =>
  Array.isArray(value) ? value[0] : value;

export const getSafeAuthReturnPath = (value: string | string[] | undefined): string | null => {
  const rawPath = getQueryStringValue(value);
  if (!rawPath) return null;

  let decodedPath = rawPath;
  try {
    decodedPath = decodeURIComponent(rawPath);
  } catch {
    decodedPath = rawPath;
  }

  if (!decodedPath.startsWith('/') || decodedPath.startsWith('//')) return null;

  try {
    const url = new URL(decodedPath, 'https://eezi.invalid');
    if (url.origin !== 'https://eezi.invalid' || !isAppRoutePath(url.pathname)) return null;

    url.searchParams.delete('loop');
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
};

export const rememberAuthReturnPath = (value: string | string[] | undefined): string | null => {
  const returnPath = getSafeAuthReturnPath(value);
  if (typeof window === 'undefined') return returnPath;

  if (returnPath) {
    window.sessionStorage.setItem(AUTH_RETURN_PATH_KEY, returnPath);
  } else {
    window.sessionStorage.removeItem(AUTH_RETURN_PATH_KEY);
  }

  return returnPath;
};

export const getAuthReturnPath = (value?: string | string[]): string => {
  const requestedPath = getSafeAuthReturnPath(value);
  if (requestedPath) return requestedPath;
  if (typeof window === 'undefined') return '/dashboard/';

  return getSafeAuthReturnPath(window.sessionStorage.getItem(AUTH_RETURN_PATH_KEY) ?? undefined) ?? '/dashboard/';
};

export const clearAuthReturnPath = (): void => {
  if (typeof window !== 'undefined') {
    window.sessionStorage.removeItem(AUTH_RETURN_PATH_KEY);
  }
};
